import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'styles/base/reset.css';
import 'styles/base/global.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
